<h5 class="mobile-nav-title" i18n>Quotes</h5>
<div class="container-fluid mb-5">
    <a *ngIf="canAddQuote" routerLink="/quote/add" class="mb-2 btn btn-bidit-submit" i18n>Add Quote</a>
    <form class="row" (ngSubmit)="loadQuotes()">
      <div class="col-sm-2">
        <input name="projectName" id="projectName"
               class="form-control" placeholder="Search Projects" i18n-placeholder
               [(ngModel)]="filter.projectName" #projectName="ngModel" />
      </div>
      <div class="col-sm-2">
        <select name="dateRange" id="dateRange"
                class="form-control select-bidit"
                [(ngModel)]="filter.dateRange" #dateRange="ngModel">

          <option value="null" i18n>Select Created Date Range</option>
          <option value="1" i18n>Current Month</option>
          <option value="2" i18n>Current Quarter</option>
          <option value="3" i18n>Current Year</option>
          <option value="4" i18n>Prior Month</option>
          <option value="5" i18n>Prior Quarter</option>
          <option value="6" i18n>Prior Year</option>
        </select>
      </div>
      <div class="col-sm-2">
        <select name="jobTypeId" id="jobTypeId"
                class="form-control select-bidit"
                [(ngModel)]="filter.jobTypeId" #salespersonId="ngModel">
          <option [ngValue]="null" i18n>Select Job Type</option>
          <option *ngFor="let jobType of summary?.jobTypes" [ngValue]="jobType.jobType_ID">{{jobType.jobType_Desc}}</option>
        </select>
      </div>
      <div class="col-sm-2">
        <select name="salespersonId" id="salespersonId"
                class="form-control select-bidit"
                [(ngModel)]="filter.salespersonId" #salespersonId="ngModel">
          <option value="" i18n>Select Salesperson</option>
          <option *ngFor="let salesperson of summary?.salespersons" [ngValue]="salesperson.id">{{salesperson.lastName}}, {{salesperson.firstName}}</option>
        </select>
      </div>
      <div class="col-sm-2">
        <select name="statusId" id="statusId"
                class="form-control select-bidit"
                [(ngModel)]="filter.statusId" #salespersonId="ngModel">
            <option [ngValue]="undefined" i18n>Select Status</option>
          <option value="1" selected i18n>Active Quotes</option>
          <option value="2" i18n>Lost Quotes</option>
          <option value="3" i18n>Expired Quotes</option>
          <option [ngValue]="undefined" i18n>All Statuses</option>
        </select>
      </div>
      <div class="col-sm-2 mb-1">
        <button type="submit" class="text-white btn btn-bidit-navigate float-right" i18n>Apply Filter</button>
      </div>
    </form>

  <div
        infiniteScroll
        [infiniteScrollDistance]="2"
        [infiniteScrollThrottle]="50"
        (scrolled)="onScroll()">
    <div *ngFor="let quote of quotes">
      <div class="card bg-light border-bidit-dark mb-3 shadow">
        <div class="card-body text-bidit-primary">
          <div class="col">
            <span class="text-bidit-primary-header">{{quote.customer?.customer_BusinessName}}</span>
          </div>
          <span class="form-inline col">
            <label for="quoteName" i18n>Project Name:</label>
            <a class="mobile-link" routerLink="/quote/{{quote.quote_ID}}">
              {{quote.quote_Name}} #{{quote.quote_ProjectNumber}}
            </a>
          </span>
          <div class="col">
            <div class="row">
              <div class="col-6">
                <div class="form-inline">
                  <label for="quote_BidAmount" i18n>Bid Amount:</label>
                  <span id="quote_BidAmount">{{quote.quote_BidAmount | currency}}</span>
                </div>
                <div *ngFor="let quoteAssignment of quote.quoteAssignments">
                  <div *ngIf="quoteAssignment.assignedTo" class="form-inline">
                    <label for="salesPerson" i18n>Salesperson:</label>
                    <span id="salePerson">
                      {{quoteAssignment.assignedTo.lastName}}, {{quoteAssignment.assignedTo.firstName}}
                    </span>
                  </div>
                </div>
                <div class="form-inline">
                  <label for="acknowledgementStatus" i18n>Acknowledged Status:</label>
                  <span id="acknowledgementStatus">{{quote.acknowledgementStatus}}</span>
                </div>

              </div>
              <div class="col-6">
                <div *ngIf="quote.jobType" class="form-inline">
                  <label for="quote_jobType" i18n>Job Type:</label>
                  <span id="quote_jobType">{{quote.jobType.jobType_Desc}}</span>
                </div>
                <div class="form-inline">
                  <label for="convertedDate" i18n>Quote Date:</label>
                  <span id="convertedDate">{{quote.quote_QuoteDate | date:'MM/dd/yyyy'}}</span>
                </div>
                <div class="form-inline">
                  <label i18n>Status:</label>
                  <div *ngIf="quote.quote_IsLost" i18n>Lost</div>
                  <div *ngIf="quote.isExpired" i18n>Expired</div>
                  <div *ngIf="quote.quote_IsLost == false && quote.isExpired == false" i18n>Active</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
